
const testerRoleExists = Roles => {
    let dev = Roles.filter(role => {
        return role.roleName === 'tester';
    });
    return dev.length > 0;
};

export default testerRoleExists